import { BookFeature } from '../../models/book-feature';

export class BookFeatureDataChangedEvent {

    bookFeature: BookFeature;
    pageId: number;
    cacheOnly: boolean;

    static createEvent(bookFeature: BookFeature): BookFeatureDataChangedEvent {

        const event = new BookFeatureDataChangedEvent();
        event.bookFeature = bookFeature;
        event.pageId = bookFeature.pageId;

        return event;

    }

}
